import {InputPhone} from '@/components/commons/input-phone/InputPhone'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {PatientContactsSchema} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import {isValidPhoneNumber} from 'react-phone-number-input'
import {StyledContactNotes} from './style'

export const ContactPhoneField = ({index}: {index: number}) => {
    const {t} = useTranslation()
    const {control, setValue} = useFormContext<{
        contacts: PatientContactsSchema
    }>()
    const {field, fieldState} = useController({control, name: `contacts.${index}.contact`})

    const fieldNote = useMemo(() => {
        return field.value
    }, [])

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <InputPhone
                placeholder={t('commons:phone_placeholder')}
                onCallingCountryChangeCb={() => setValue(`contacts.${index}.contact`, '')}
                fullWidth
                errorMessage={fieldState.error?.message}
                {...field}
            />
            {fieldNote && !isValidPhoneNumber(fieldNote) && !fieldState.isDirty && (
                <StyledContactNotes size="textXs" palette="neutral" shade="500">
                    <Text render="span">{t('commons:notes')}: </Text>
                    <Text render="span" palette="neutral" shade="950">
                        {fieldNote}
                    </Text>
                </StyledContactNotes>
            )}
        </Flexbox>
    )
}
